var extend = require('../util/extend');

module.exports = extend({}, require('./base'), require('./login'), require('./share'), require('./device'), require('./scan'), require('./image'), require('./log'), require('./webview'), require('./navigation'), require('./window'), require('./scheme'));


//////////////////
// WEBPACK FOOTER
// ../src/apis/index.js
// module id = 10
// module chunks = 0 2 4